<template>
  <span class="healing-markers">
    <Button
      v-uEdition="'YZ-20'"
      v-bind="buttonProps"
      class="ubtn_icon"
      size="small"
      @click="openWin"
      >治愈标记</Button
    >
    <Modal
      v-model="showWin"
      title="治愈标记"
      @on-cancel="cancel"
      footer-hide
      width="700"
    >
      <div class="healing-markers-modal">
        <div class="header">
          <div class="patient-info">
            <span class="patient-name">{{ info.patientName }}</span>
            <span v-if="info.sex">{{ info.sex }}</span>
            <span v-if="info.patientAge !== null">{{ info.patientAge }}岁</span>
            <span>{{ info.cellphoneNo }}</span>
          </div>
          <div class="tip" v-if="courseInfo.startDate">
            请标记该患者最近一个病程中（{{ courseInfo.startDate }}至{{
              courseInfo.endDate
            }}）已治愈的病种
          </div>
        </div>
        <Table :columns="columns1" :data="courseInfo.detailVOS || []">
          <template slot-scope="{ row }" slot="auditResult">
            <span :class="className(row.auditResult)">{{
              common.valueToLabel(auditResultList, row.auditResult)
            }}</span>
          </template>
          <template slot-scope="{ row }" slot="auditDate">
            <span>{{ row.auditDate || "/" }}</span>
          </template>
          <template slot-scope="{ row }" slot="markType">
            <!-- false-color="#ff4949" -->
            <i-switch
              true-color="green"
              :disabled="switchDisabled(row)"
              :true-value="1"
              :false-value="0"
              v-model="row.markType"
              @on-change="markTypeChange(row, $event)"
            />
          </template>
        </Table>
        <Spin v-if="indexSpin.show" fix></Spin>
      </div>
    </Modal>
  </span>
</template>

<script>
import request from "@/utils/request";
import { mapGetters } from "vuex";
import dayjs from "dayjs";
export default {
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
    buttonProps: {
      type: Object,
      default: () => ({
        icon:"md-pricetag",
        shape:"circle"
      }),
    },
  },
  computed: {
    ...mapGetters(["userInfo", "indexSpin"]),
  },
  data() {
    return {
      auditResultList: [
        {
          value: null,
          label: "/",
        },
        {
          value: 0,
          label: "待确认",
        },
        {
          value: 1,
          label: "已治愈",
        },
        {
          value: 2,
          label: "未治愈",
        },
      ],
      showWin: false,
      courseInfo: {
        detailVOS: [],
      },
      columns1: [
        {
          title: "病种",
          key: "diseaseName",
          width: 120,
        },
        {
          title: "患者确认是否治愈",
          key: "auditResult",
          slot: "auditResult",
        },
        {
          title: "确认时间",
          key: "auditDate",
          slot: "auditDate",
          width: 170,
        },
        {
          title: "医生标记是否治愈",
          key: "markType",
          slot: "markType",
        },
      ],
    };
  },
  methods: {
    className(res) {
      switch (res) {
        case 1:
          return "green";
        case 2:
          return "red";
        default:
          return "";
      }
    },
    cancel() {
      this.showWin = false;
    },
    openWin() {
      this.getData();
      this.showWin = true;
    },
    switchDisabled(row) {
      let flog = false;
      if (row.auditResult == 1) {
        flog = true;
      } else if (row.auditResult == 2) {
        return dayjs(row.auditDate).isSame(dayjs(), "day");
      }
      return flog;
    },
    markTypeChange(item, val) {
      let msg = val
        ? `确认标记${item.diseaseName}已治愈？`
        : `取消${item.diseaseName}的治愈标记？`;
      this.$Modal.confirm({
        title: "提示",
        content: msg,
        onOk: () => {
          let obj = {
            diseaseId: item.diseaseId,
            diseaseName: item.diseaseName,
            hospitalCode: this.userInfo.hosptialCode,
            patientCode: this.info.patientCode,
            pdcId: item.pdcId,
            pdccId: item.pdccId,
          };
          request.post("/saasbaihui/yzMarkDisease", obj).then((res) => {
            this.$Message.success("操作成功");
            this.getData();
          });
        },
        onCancel: () => {
          item.markType = val ? 0 : 1;
        },
      });
    },
    getData() {
      request
        .post("/saasbaihui/getYzCourseInfo", {
          patientCode: this.info.patientCode,
        })
        .then((res) => {
          this.courseInfo = res.result;
        });
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.healing-markers {
}
</style>
<style lang="scss">
.healing-markers-modal {
  .patient-info {
    margin-bottom: 10px;
    & > span {
      margin-right: 15px;
    }
    .patient-name {
      font-size: 16px;
      font-weight: bold;
    }
  }
  .tip {
    margin-bottom: 15px;
  }
  .ivu-table {
    background: none;
  }
  .ivu-table td,
  .ivu-table th {
    background: none;
    border-bottom: 1px solid #ccc;
  }
}
</style>